import React from 'react';
import PropTypes from 'prop-types';
import Pic1 from './assets/shutterstock_152507294.png';
import Pic2 from './assets/shutterstock_212968645.png';
import Pic3 from './assets/shutterstock_228939415.png';
import Pic4 from './assets/shutterstock_261385457.png';
import Pic5 from './assets/shutterstock_489519301.png';
import Pic6 from './assets/shutterstock_568319044.png';
import Pic7 from './assets/shutterstock_587513495.png';
import Pic8 from './assets/shutterstock_611808665.png';
import Pic9 from './assets/shutterstock_616060073.png';
import Pic10 from './assets/shutterstock_638351104.png';
import Pic11 from './assets/shutterstock_652377421.png';
import Pic12 from './assets/shutterstock_666769963.png';
import Pic13 from './assets/shutterstock_676869007.png';
import Pic14 from './assets/shutterstock_687008515.png';
import Pic15 from './assets/shutterstock_688478083.png';
import Pic16 from './assets/shutterstock_793500085.png';
import Pic17 from './assets/shutterstock_1091337098.png';
import Pic18 from './assets/shutterstock_1230016774.png';
import Pic19 from './assets/shutterstock_1238855797.png';
import Pic20 from './assets/shutterstock_1303746388.png';
import './PostPicture.css';

const pics = [
  Pic1,
  Pic2,
  Pic3,
  Pic4,
  Pic5,
  Pic6,
  Pic7,
  Pic8,
  Pic9,
  Pic10,
  Pic11,
  Pic12,
  Pic13,
  Pic14,
  Pic15,
  Pic16,
  Pic17,
  Pic18,
  Pic19,
  Pic20
];

function mapTimeToPicNumber(date) {
  return pics[date.valueOf() % pics.length];
}

function PostPicture({ date, alt }) {
  return (
    <img className="post-picture" src={mapTimeToPicNumber(date)} alt={alt} />
  );
}

PostPicture.propTypes = {
  date: PropTypes.instanceOf(Date)
};

export default PostPicture;
